import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['kindInput', 'listSection']

  connect () {
    this.#syncListSection()
  }

  kindChanged () {
    this.#syncListSection()
  }

  #syncListSection () {
    if (!this.hasKindInputTarget || !this.hasListSectionTarget) return

    this.listSectionTarget.hidden = this.kindInputTarget.value !== 'list'
  }
}
